import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { PlusIcon, MinusIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-warmGray last:border-0" data-id="element-47">
      <button onClick={onClick} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" aria-expanded={isOpen} data-id="element-48">
        <span className="text-lg md:text-xl font-bold text-charcoal group-hover:text-amber transition-colors" data-id="element-49">
          {question}
        </span>
        <span className="ml-6 shrink-0 text-amber" data-id="element-50">
          {isOpen ? <MinusIcon className="w-6 h-6" data-id="element-51" /> : <PlusIcon className="w-6 h-6" data-id="element-52" />}
        </span>
      </button>
      <AnimatePresence data-id="element-53">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-54">
            <p className="pb-6 text-charcoal/80 leading-relaxed text-lg" data-id="element-55">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'My parents have an Android, will this work?',
    answer: 'Yes. The guide uses universal icons and concepts that apply to both iPhone and Android devices.'
  }, {
    question: 'Can I print this for them?',
    answer: "Absolutely. In fact, we encourage it. It's formatted for easy printing with high-contrast text for older eyes."
  }, {
    question: "What if they are truly 'hopeless' with tech?",
    answer: 'If they can use a microwave or a TV remote, they can use this guide. It was written specifically for the beginner brain.'
  }];
  return <section className="bg-white py-24 px-6" data-id="element-56">
      <div className="max-w-3xl mx-auto" data-id="element-57">
        <FadeIn data-id="element-58">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-59">
            Frequently Asked Questions
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-60">
          <div className="bg-cream rounded-3xl p-6 md:p-10 shadow-sm border border-warmGray" data-id="element-61">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-62" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
}